module.exports = __webpack_public_path__ + "img/banner_01.26c7a8ea.jpg";